import React from 'react'
import ReactDOM from 'react-dom'

import { initializeApp } from 'firebase/app'

import App from './components/App'

initializeApp({
  apiKey: "AIzaSyBXJ2f1hNiE7NVdNSfV3tVZ6a0iozQHXO4",
  authDomain: "gastrosoft-52af2.firebaseapp.com",
  projectId: "gastrosoft-52af2",
  storageBucket: "gastrosoft-52af2.firebasestorage.app",
  messagingSenderId: "1023489682712",
  appId: "1:1023489682712:web:926848a7c27f222521c26d",
  measurementId: "G-R50TB1LW49"
})

const app = document.getElementById('app')

ReactDOM.render(<App />, app)
